import { test, compose, split, join, filter } from "ramda";

// Strips all characters except numbers
export const sanitizePhone = compose(
  join(""),
  filter(test(/[0-9]/)),
  split("")
);
